class ModalsDinamic {
  static instance;

  static callbackFunction;

  static setOptions = () => {};

  static closeFunction = () => {};

  static getInstance() {
    if (!ModalsDinamic.instance) {
      ModalsDinamic.instance = new ModalsDinamic();
    }
    return ModalsDinamic.instance;
  }

  setCallbackFunction(fn) {
    ModalsDinamic.callbackFunction = fn;
  }

  setCloseFunction(fn) {
    ModalsDinamic.closeFunction = fn;
  }

  setSetOptionsFunction(fn) {
    ModalsDinamic.setOptions = fn;
  }

  setOptions(options) {
    ModalsDinamic.setOptions(options);
  }

  openModal(options) {
    if (!ModalsDinamic.callbackFunction) return;
    ModalsDinamic.callbackFunction(options);
  }

  warn(options) {
    this.openModal({ ...options, iconName: "fa fa-exclamation-circle", iconColor: "warning" });
  }

  info(options) {
    this.openModal({ ...options, iconName: "fa fa-info-circle", iconColor: "info" });
  }

  danger(options) {
    this.openModal({ ...options, iconName: "fa fa-warning", iconColor: "error" });
  }

  close() {
    ModalsDinamic.closeFunction();
  }
}

export const $modalsdinamic = ModalsDinamic.getInstance();

export default (vue) => {
  vue.prototype.$modalsDinamic = $modalsdinamic;
};
